import { render } from "./AddSliderAwardHome.vue?vue&type=template&id=19a83f05&scoped=true"
import script from "./AddSliderAwardHome.vue?vue&type=script&lang=js"
export * from "./AddSliderAwardHome.vue?vue&type=script&lang=js"

import "./AddSliderAwardHome.vue?vue&type=style&index=0&id=19a83f05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a83f05"]])

export default __exports__